export default __webpack_public_path__ + "static/media/rw_main_logo_blue.5a1a4adc.png";